export default "__VITE_ASSET__DoH8DTRq__"